<template>
    <div  class="blue--text text--darken-4 ma-0 pa-0">
        <p class="ma-0 pa-0">{{number}}</p>
        <p v-if="start"
            class=" ma-0 py-0 caption grey--text text--darken-3" >from {{start| dateEU('DD/MM/YYYY')}}&nbsp;&nbsp;to&nbsp;&nbsp;{{end| dateEU('DD/MM/YYYY')}}</p>
    </div>
</template>
<script>
export default{
    props:['number','start','end']
}
</script>
